import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import LogoKekar from "../../Picture/logoKekar.png";
import LogoOwner from "../../Picture/logoOwner.png";
import { useNavigate } from "react-router-dom";

const Home =(props)=>{
    const url=props.url;
    const navigate=useNavigate();
    const [password,setPassword]=useState("");
    const [keteranganPassword,setKeteranganPassword]=useState("");
    const [pilihanLogin,setPilihanLogin]=useState("");

    // function Pilihan Login
    const PilihanLogin=(value)=>{
setPilihanLogin(value);
    }

    // fucntion Kirim
   const Kirim = () => {
    if(pilihanLogin ==""){
        setKeteranganPassword("Silakan pilih dahulu");
    }else{
  fetch(url + "/?op=getAkun", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    credentials: "include", 
    body: "password=" + password + "&pilihan_login=" + pilihanLogin,
  })
    .then((response) => response.json())
    .then((json) => {


      if (json === "benar") {

              setKeteranganPassword("");
        fetch(url + "/?op=cekSession", {
    credentials: "include", 
  })
  .then((response)=>response.json())
  .then((json)=>{


   if(json=="gym1"){
    navigate("/gym1");
   }else if(json=="gym2"){
 navigate("/gym2");
 
   }else if(json=="owner"){
 navigate("/owner");
 
   } else if (json === "kosong") {
        navigate("/", { replace: true });
      }
  })
        
      } else {
      setKeteranganPassword("Password Salah");
      }
    });
}
};
// use effect
useEffect(()=>{
fetch(url + "/?op=cekSession", {
    credentials: "include", 
  })
  .then((response)=>response.json())
  .then((json)=>{


   if(json=="gym1"){
    navigate("/gym1");
   }else if(json=="gym2"){
 navigate("/gym2");
   } else if (json === "kosong") {
        navigate("/", { replace: true });
      }
  })
},[])

// 
    return(
        <div className={style.containerAll}>
<div className={style.divJudul}>
    KEKE's GYM
    </div>
    <div className={style.divIsi}>
<div className={style.divLogin}>
<div className={style.tulisanLogin}>
Login
</div>
<div className={style.pilihanLogin}>
<div onClick={()=>PilihanLogin("loginGym1")} style={{borderColor:pilihanLogin == "loginGym1"?"blue":""}} className={style.kotakPilihan}>
<img className={style.logoGym} src={LogoKekar} />
<div >
Gym 1
</div>
</div>
<div onClick={()=>PilihanLogin("loginGym2")} style={{borderColor:pilihanLogin == "loginGym2"?"blue":""}} className={style.kotakPilihan}>
<img className={style.logoGym} src={LogoKekar} />
<div >
Gym 2
</div>
</div>
<div onClick={()=>PilihanLogin("loginOwner")} style={{borderColor:pilihanLogin == "loginOwner"?"blue":""}} className={style.kotakPilihan}>
<img className={style.logoOwner} src={LogoOwner} />
<div >
Owner
</div>
</div>
</div>
<div className={style.divIsianPassword}>
<input type="password" value={password} onChange={(e)=>setPassword(e.target.value)}/>
<button onClick={()=>Kirim()}>
    Kirim
</button>
</div>
<div className={style.divKeteranganPassword}>
{keteranganPassword}
</div>
</div>
    </div>
        </div>
    )
}
export default Home;